// components/dialogs/CustomPromoDialog.js
import React, { useState } from 'react';
import { alertC } from './components/dialogService';

const CustomPromoDialog = ({ isOpen, onClose, onSave }) => {
  const [name, setName] = useState('');
  const [discount, setDiscount] = useState('');
  const [type, setType] = useState('%');
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [expDate, setExpDate] = useState('');

  const handleSave = () => {
    if (!name.trim()) return alertC('Promotion name is required.');
    if (!discount || isNaN(discount) || discount <= 0) return alertC('Enter valid discount.');
    if (!expDate) return alertC('Expiration date is required.');

    const customPromo = {
      id: `custom-${Date.now()}`,
      name: name.trim(),
      discount: Number(discount),
      discount_type: type,
      visible: true,
      applies_to: 'subtotal_only',
      start_date: startDate,
      expiration_date: expDate,
    };

    onSave(customPromo);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content-modal-dialog"
        style={{ maxWidth: '420px', padding: '20px' }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ marginTop: 0 }}>Create Custom Promotion</h3>

        <label style={{ display: 'block', margin: '12px 0 4px' }}>
          Promotion Name:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ width: '100%', padding: '6px' }}
            placeholder="e.g. Summer Sale"
          />
        </label>

        <label style={{ display: 'block', margin: '12px 0 4px' }}>
          Discount:
          <div style={{ display: 'flex', gap: '8px' }}>
            <input
              type="number"
              value={discount}
              onChange={(e) => setDiscount(e.target.value)}
              style={{ flex: 1, padding: '6px' }}
              placeholder="10"
              min="0"
              step="0.01"
            />
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              style={{ width: '90px', padding: '6px' }}
            >
              <option value="%">%</option>
              <option value="amount">$</option>
            </select>
          </div>
        </label>

        <label style={{ display: 'block', margin: '12px 0 4px' }}>
          Start Date:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{ width: '100%', padding: '6px' }}
          />
        </label>

        <label style={{ display: 'block', margin: '12px 0 4px' }}>
          Expiration Date:
          <input
            type="date"
            value={expDate}
            onChange={(e) => setExpDate(e.target.value)}
            style={{ width: '100%', padding: '6px' }}
            min={startDate}
          />
        </label>

        <div style={{ marginTop: '20px', textAlign: 'right' }}>
          <button
            onClick={onClose}
            style={{ marginRight: '8px', padding: '6px 12px', background: '#f0f0f0' }}
          >
            Close
          </button>
          <button
            onClick={handleSave}
            style={{
              padding: '6px 16px',
              background: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
            }}
          >
            Add Promotion
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomPromoDialog;